"use client";

import { Flex, Heading } from "@chakra-ui/react";
import React from "react";

import { ColorModeButton } from "@components/ui/color-mode";
import CartIconButton from "@features/marketplace/navigation/CartIconButton";
import { useRouter } from "next/navigation";

const TopBar = () => {
  const router = useRouter();
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      p={1}
      alignItems="center"
    >
      <Heading
        size="md"
        userSelect="none"
        onClick={() => router.push("/")}
        cursor="pointer"
      >
        The Anabel Rose Store
      </Heading>
      <Flex flexDirection="row" gap={2} alignItems="center">
        <ColorModeButton
          _hover={{
            backgroundColor: "sidebar.hover",
          }}
        />
        <CartIconButton />
        {/* <UserAvatarMenu shouldRedirectToLogin={false} /> */}
      </Flex>
    </Flex>
  );
};

export default React.memo(TopBar);
